module.exports = __webpack_public_path__ + "img/port4.8040bad0.png";